export function canvasGetImageData(canvas, x, y, w, h, flipXY = true) {
  const context = canvas.getContext("2d");
  const image = context.getImageData(x, y, w, h);
  //   const ditherImage = Dither.threshold(image, 128);

  let data = [];

  if (flipXY) {
    for (let x = 0; x < image.width; x++) {
      for (let y = image.height; y-- > 0; ) {
        let off = (y * image.width + x) * 4;
        const gray =
          (image.data[off] + image.data[off + 1] + image.data[off + 2]) / 3;
        const alpha = image.data[off + 3];
        data.push(gray > 128 || alpha < 128 ? 0 : 1);
      }
    }

    return [data, image.height, image.width];
  } else {
    for (let y = 0; y < image.height; y++) {
      for (let x = 0; x < image.width; x++) {
        let off = (y * image.width + x) * 4;
        const gray =
          (image.data[off] + image.data[off + 1] + image.data[off + 2]) / 3;
        const alpha = image.data[off + 3];
        data.push(gray > 128 || alpha < 128 ? 0 : 1);
      }
    }

    return [data, image.width, image.height];
  }
}
